<template>
  <div>
    <template v-for="(el, key) in json.blocks">
      <template v-if="el">
        <!-- Paragraph -->
        <div :key="key" v-if="el.type == 'paragraph'" class="parrafo">
          <p v-html="el.data.text"></p>
        </div>

        <!-- Image -->
        <template v-else-if="el.type == 'image'">
          <div :key="key" class="contenedor-imagen">
            <img :src="el.data.file.url" class="img-full" alt="img full" />
            <span v-html="el.data.caption" class="pie"></span>
          </div>
        </template>

        <!-- Header -->
        <h4
          :key="key"
          :nivel="el.data.level"
          v-else-if="el.type == 'header'"
          class="destacado"
          v-html="el.data.text"
        ></h4>

        <!-- Embed -->

        <div class="mask-video" v-if="el.type == 'embed'">
          
            <div v-show="el.data.service == 'vimeo' || el.data.service == 'youtube'"
            @click="removeCapaVideo"
            class="capa"
            :class="[capaVideo == false ? 'capa disabled-capa' : 'capa']"
          ></div>
         
         
          <iframe
            :service="el.data.service"
            :key="key"
            :src="el.data.embed"
            v-if="el.type == 'embed'"
          ></iframe>
        </div>

        <!-- File -->
        <div
          :key="key"
          class="descargable row-center"
          v-else-if="el.type == 'attaches'"
        >
          <a
            :href="el.data.file.url"
            class="btn-descargable"
            rel="noopener"
            target="_blank"
          >
            <span v-if="!!el.data.title">{{ el.data.title }}</span>
          </a>

          <a href="" class="btn-descargable">Descargar</a>
        </div>

        <!-- Slider -->
        <div
          class="slider-imagenes"
          :key="key"
          v-else-if="el.type == 'gallery'"
        >
          <slick ref="slick" :options="slickOptions">
            <div class="slide" v-for="(img, key) in el.data.images" :key="key">
              <div
                class="img-slide"
               :title="img.caption"
                :style="`background-image:url(` + img.file.url + `)`" 
              ></div>
              <!-- <img :src="img.file.url" :alt="img.caption" /> -->
            </div>
          </slick>
        </div>
      

        <!-- Prety Link -->
        <div
          :key="key"
          class="contenedor-link row-center"
          v-if="el.type == 'linkTool'"
        >
          <div class="link row-start">
            <a
              :href="el.data.link"
              rel="noopener"
              target="_blank"
            >
            <img
              v-if="!!el.data.meta.image"
              :src="el.data.meta.image.url"
              alt="imagen"
            />
            <h2>{{ el.data.meta.title }}</h2>
            <p>{{ el.data.meta.description }}</p>
            </a>
          </div>
        </div>

        <!-- List -->
        <span
          :key="key"
          v-else-if="el.type == 'list' || el.type == 'nestedList'"
        >
          <list-component :items="el.data.items" :listType="el.data.style" />
        </span>

        <!-- Boton -->
        <div :key="key" class="boton" v-else-if="el.type == 'button'">
          <a target="_blank" :href="el.enlace" class="btn-rounded-blue">{{
            el.data.text
          }}</a>
        </div>

        <!-- Tabla -->
        <div class="table-container" :key="key" v-else-if="el.type == 'table'">
          <table>
            <tr v-for="(td, tdkey) in el.data.content" :key="tdkey">
              <td :key="ekey" v-for="(e, ekey) in td" v-html="e"></td>
            </tr>
          </table>
        </div>

        <!-- Columnas -->
        <div
          class="columnas row-center"
          v-else-if="el.type == 'columns'"
          :key="key"
        >
          <div
            class="columna"
            v-for="(el, key) in el.data.itemContent"
            :key="key"
          >
            <editorjs :object="el"></editorjs>
          </div>
        </div>

        <!-- Raw -->
        <div :key="key" v-else-if="el.type == 'raw'" class="raw">
          <div v-html="el.data.html"></div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";

/* Import */
const ListComponent = {
  template:
    '<component :is="type">' +
    '<span :key="key" v-for="(subitem,key) in listItems">' +
    '<li v-html="$options.filters.getHtml(subitem)"></li>' +
    '<list-component v-if="subitem.items" :items="subitem.items" :listType="listType"/>' +
    "</span>" +
    "</component>",
  name: "ListComponent",
  props: {
    items: {
      type: [Array],
      required: true
    },
    listType: {
      type: [String],
      required: true
    }
  },
  data() {
    return {
      listItems: this.items,
      type: this.listType == "unordered" ? "ul" : "ol"
    };
  },
  filters: {
    getHtml(subitem) {
      return subitem.content ? subitem.content : subitem;
    }
  }
};

export default {
  name: "editorjs",
  props: ["object"],
  computed: {
    json() {
      if (typeof this.object === "string" || this.object instanceof String) {
        return JSON.parse(this.object);
      }
      return this.object;
    }
  },
  data: () => ({
    capaVideo: true,
    slickOptions: {
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: false,
      dots: false,
      arrows: true,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 920,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 2
          }
        }
      ]
    }
  }),
  components: {
    Slick,
    ListComponent
  },
  methods: {
    removeCapaVideo: function() {
      this.capaVideo = false;
    }
  },
  filters: {}
};
</script>



// WEBPACK FOOTER //
// src/components/views/editorjs.vue